/**
 * Automation workflow merge-field definitions for Custom Values picker.
 * TODO: Replace static custom_values fields with GET /api/automations/merge-fields when available.
 */

const field = (label, value, searchTerms = []) => ({ label, value, searchTerms });

export const STATIC_MERGE_FIELD_CATEGORIES = [
  {
    key: 'contact',
    label: 'Contact',
    fields: [
      field('Full Name', '{{contact.full_name}}'),
      field('First Name', '{{contact.first_name}}'),
      field('Last Name', '{{contact.last_name}}'),
      field('Email', '{{contact.email}}'),
      field('Phone', '{{contact.phone}}'),
      field('Phone (raw format)', '{{contact.phone_raw}}'),
      field('Company Name', '{{contact.company_name}}'),
      field('Full Address', '{{contact.full_address}}'),
      field('Address 1', '{{contact.address1}}'),
      field('City', '{{contact.city}}'),
      field('State', '{{contact.state}}'),
      field('Country', '{{contact.country}}'),
      field('Postal Code', '{{contact.postal_code}}'),
      field('Timezone', '{{contact.timezone}}'),
      field('Timezone (raw format)', '{{contact.timezone_raw}}'),
      field('Date of birth', '{{contact.date_of_birth}}'),
      field('Source', '{{contact.source}}'),
      field('Contact Type', '{{contact.type}}'),
      field('Website', '{{contact.website}}'),
      field('ID', '{{contact.id}}'),
    ],
    children: [
      {
        key: 'contact_custom_fields',
        label: 'Custom Fields',
        fields: [
          field('Custom Field 1', '{{contact.custom_field_1}}'),
          field('Custom Field 2', '{{contact.custom_field_2}}'),
        ],
      },
    ],
  },
  {
    key: 'agency',
    label: 'Agency',
    fields: [
      field('Agency Name', '{{agency.name}}'),
      field('Agency Phone', '{{agency.phone}}'),
      field('Agency Email', '{{agency.email}}'),
      field('Agency Website', '{{agency.website}}'),
      field('Agency Address', '{{agency.address}}'),
      field('Agency State', '{{agency.state}}'),
      field('Agency City', '{{agency.city}}'),
      field('Agency Description', '{{agency.description}}'),
      field('Agency Logo URL', '{{agency.logo_url}}'),
      field('Agency Portal URL', '{{agency.portal_url}}'),
      field('Agency Support Email', '{{agency.support_email}}', ['support email', 'support']),
      field('Agency Support Phone', '{{agency.support_phone}}', ['support phone', 'support']),
      field('Company Name legacy', '{{company.name}}', ['company name', 'company']),
      field('Company Email legacy', '{{company.email}}', ['company email', 'company']),
      field('Company Phone legacy', '{{company.phone}}', ['company phone', 'company']),
      field('Company Website legacy', '{{company.website}}', ['company website', 'company']),
    ],
  },
  {
    key: 'admin',
    label: 'Admin',
    fields: [
      field('Admin Full Name', '{{admin.full_name}}'),
      field('Admin First Name', '{{admin.first_name}}'),
      field('Admin Last Name', '{{admin.last_name}}'),
      field('Admin Email', '{{admin.email}}', ['admin email']),
      field('Admin Phone', '{{admin.phone}}'),
      field('Admin Role', '{{admin.role}}'),
      field('Admin Signature', '{{admin.signature}}'),
      field('Platform Name', '{{platform.name}}'),
      field('Platform Support Email', '{{platform.support_email}}', ['support email', 'support']),
      field('Platform Support Phone', '{{platform.support_phone}}', ['support phone', 'support']),
      field('Platform URL', '{{platform.url}}'),
    ],
  },
  {
    key: 'staff',
    label: 'Staff',
    fields: [
      field('Staff Full Name', '{{staff.full_name}}', ['user full name', 'assigned user full name']),
      field('Staff First Name', '{{staff.first_name}}', ['user first name', 'assigned user first name']),
      field('Staff Last Name', '{{staff.last_name}}', ['user last name', 'assigned user last name']),
      field('Staff Email', '{{staff.email}}', ['user email', 'assigned user email']),
      field('Staff Phone', '{{staff.phone}}', ['user phone', 'assigned user phone']),
      field('Staff Phone (raw format)', '{{staff.phone_raw}}', ['user phone raw']),
      field('Staff Signature', '{{staff.signature}}', ['user signature']),
      field('Staff Calendar Link', '{{staff.calendar_link}}', ['user calendar link']),
      field('Staff Twilio Phone', '{{staff.twilio_phone}}', ['user twilio phone']),
      field('Staff ID', '{{staff.id}}', ['user id']),
    ],
  },
  {
    key: 'appointment',
    label: 'Appointment',
    fields: [
      field('ID', '{{appointment.id}}'),
      field('Title', '{{appointment.title}}'),
      field('Start Date Time', '{{appointment.start_datetime}}'),
      field('Start Date', '{{appointment.start_date}}'),
      field('Start Time', '{{appointment.start_time}}'),
      field('End Date Time', '{{appointment.end_datetime}}'),
      field('End Date', '{{appointment.end_date}}'),
      field('End Time', '{{appointment.end_time}}'),
      field('Day of the week', '{{appointment.day_of_week}}'),
      field('Month', '{{appointment.month}}'),
      field('Name of Month', '{{appointment.month_name}}'),
      field('Timezone', '{{appointment.timezone}}'),
      field('Cancellation Link', '{{appointment.cancellation_link}}'),
      field('Reschedule Link', '{{appointment.reschedule_link}}'),
      field('Meeting Location', '{{appointment.meeting_location}}'),
      field('Notes', '{{appointment.notes}}'),
      field('Cancellation Reason', '{{appointment.cancellation_reason}}'),
      field('Add to Google Calendar', '{{appointment.add_to_google_calendar}}'),
      field('Add to iCal/Outlook', '{{appointment.add_to_ical_outlook}}'),
    ],
    children: [
      {
        key: 'appointment_recurring',
        label: 'Recurring',
        fields: [
          field('Recurring Rule', '{{appointment.recurring.rule}}'),
          field('Recurring End Date', '{{appointment.recurring.end_date}}'),
        ],
      },
      {
        key: 'appointment_assigned_user',
        label: 'Assigned User',
        fields: [
          field('Assigned User Name', '{{appointment.assigned_user.name}}'),
          field('Assigned User Email', '{{appointment.assigned_user.email}}'),
        ],
      },
    ],
  },
  {
    key: 'calendar',
    label: 'Calendar',
    fields: [
      field('Calendar Name', '{{calendar.name}}'),
      field('Calendar Link', '{{calendar.link}}'),
      field('Calendar ID', '{{calendar.id}}'),
      field('Owner Name', '{{calendar.owner_name}}'),
      field('Owner Email', '{{calendar.owner_email}}'),
    ],
  },
  {
    key: 'message',
    label: 'Message',
    fields: [
      field('Message Body', '{{message.body}}'),
      field('Message Direction', '{{message.direction}}'),
      field('Message Channel', '{{message.channel}}'),
      field('Last Message', '{{message.last}}'),
      field('Conversation ID', '{{message.conversation_id}}'),
    ],
  },
  {
    key: 'account',
    label: 'Account',
    fields: [
      field('Account Name', '{{account.name}}'),
      field('Account Email', '{{account.email}}'),
      field('Account Phone', '{{account.phone}}'),
      field('Account Website', '{{account.website}}'),
      field('Account ID', '{{account.id}}'),
    ],
  },
  {
    key: 'right_now',
    label: 'Right now',
    fields: [
      field('Second', '{{right_now.second}}'),
      field('Minute', '{{right_now.minute}}'),
      field('Hour 24h format', '{{right_now.hour_24}}'),
      field('Hour AM/PM format', '{{right_now.hour_ampm}}'),
      field('Time 24h format', '{{right_now.time_24}}'),
      field('Time AM/PM format', '{{right_now.time_ampm}}'),
      field('AM/PM', '{{right_now.ampm}}'),
      field('Day', '{{right_now.day}}'),
      field('Day of the week', '{{right_now.day_of_week}}'),
      field('Month', '{{right_now.month}}'),
      field('Name of Month', '{{right_now.month_name}}'),
      field('Year', '{{right_now.year}}'),
      field('Date', '{{right_now.date}}'),
    ],
  },
  {
    key: 'phone_call',
    label: 'Phone Call',
    fields: [
      field('To City', '{{phoneCall.toCity}}'),
      field('From City', '{{phoneCall.fromCity}}'),
      field('To Number', '{{phoneCall.toNumber}}'),
      field('From Number', '{{phoneCall.fromNumber}}'),
      field('Call Status', '{{phoneCall.status}}'),
      field('Call Duration', '{{phoneCall.duration}}'),
    ],
  },
  {
    key: 'client_portal_contact',
    label: 'Client Portal Contact',
    fields: [
      field('Login URL (Magic Link)', '{{client_portal_contact.login_url_magic_link}}'),
    ],
  },
  {
    key: 'attribution',
    label: 'Attribution',
    fields: [
      field('Source', '{{attribution.source}}'),
      field('Medium', '{{attribution.medium}}'),
      field('Campaign', '{{attribution.campaign}}'),
      field('Term', '{{attribution.term}}'),
      field('Content', '{{attribution.content}}'),
      field('Referrer', '{{attribution.referrer}}'),
      field('Landing Page', '{{attribution.landing_page}}'),
    ],
  },
  {
    key: 'voice_ai',
    label: 'Voice AI',
    fields: [
      field('Agent Name', '{{voice_ai.agent_name}}'),
      field('Call Summary', '{{voice_ai.call_summary}}'),
      field('Call Outcome', '{{voice_ai.call_outcome}}'),
      field('Call Recording URL', '{{voice_ai.recording_url}}'),
    ],
  },
  {
    key: 'conversation_ai',
    label: 'Conversation AI',
    fields: [
      field('Conversation Summary', '{{conversation_ai.summary}}'),
      field('Last Intent', '{{conversation_ai.last_intent}}'),
      field('Suggested Reply', '{{conversation_ai.suggested_reply}}'),
    ],
  },
  {
    key: 'custom_values',
    label: 'Custom Values',
    fields: [
      field('Hours of Operation', '{{custom_values.hours_of_operation}}'),
      field('Marketing - New Booking Thank You Page URL', '{{custom_values.marketing_new_booking_thank_you_page_url}}'),
      field('Promotion Name', '{{custom_values.promotion_name}}'),
      field('Marketing Website Booking Page URL', '{{custom_values.marketing_website_booking_page_url}}'),
      field('Support Email', '{{custom_values.support_email}}', ['support email', 'support']),
      field('Support Phone', '{{custom_values.support_phone}}', ['support phone', 'support']),
    ],
  },
];

export function flattenCategoryFields(category) {
  const items = [];
  (category.fields || []).forEach((f) => {
    items.push({ ...f, categoryKey: category.key, categoryLabel: category.label });
  });
  (category.children || []).forEach((child) => {
    (child.fields || []).forEach((f) => {
      items.push({
        ...f,
        categoryKey: category.key,
        categoryLabel: category.label,
        subLabel: child.label,
      });
    });
  });
  return items;
}

export function getAllMergeFields(categories = STATIC_MERGE_FIELD_CATEGORIES) {
  return categories.flatMap(flattenCategoryFields);
}

export function searchMergeFields(query, categories = STATIC_MERGE_FIELD_CATEGORIES) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return [];

  const results = [];
  categories.forEach((category) => {
    const searchIn = (fields, subLabel) => {
      (fields || []).forEach((f) => {
        const aliasText = (f.searchTerms || []).join(' ');
        const haystack = `${category.label} ${subLabel || ''} ${f.label} ${f.value} ${aliasText}`.toLowerCase();
        if (haystack.includes(q)) {
          results.push({
            ...f,
            categoryKey: category.key,
            categoryLabel: category.label,
            subLabel,
            breadcrumb: subLabel
              ? `${category.label} > ${subLabel} > ${f.label}`
              : `${category.label} > ${f.label}`,
          });
        }
      });
    };

    searchIn(category.fields);
    (category.children || []).forEach((child) => searchIn(child.fields, child.label));
  });

  return results;
}

export function getCategoryByKey(key, categories = STATIC_MERGE_FIELD_CATEGORIES) {
  return categories.find((c) => c.key === key) || null;
}

const REQUIRED_TOP_LEVEL_CATEGORY_KEYS = new Set([
  'contact',
  'agency',
  'admin',
  'staff',
  'appointment',
  'custom_values',
]);

const MIN_CONTACT_FIELDS = 15;

/**
 * Returns true when an API payload contains the full GHL-style catalog.
 * Incomplete responses (e.g. a tiny backend stub) should not replace the static list.
 */
export function isCompleteMergeFieldCatalog(categories) {
  if (!Array.isArray(categories) || categories.length < REQUIRED_TOP_LEVEL_CATEGORY_KEYS.size) {
    return false;
  }

  const keys = new Set(categories.map((c) => c.key));
  for (const required of REQUIRED_TOP_LEVEL_CATEGORY_KEYS) {
    if (!keys.has(required)) return false;
  }

  // Legacy top-level categories must not replace the new catalog.
  if (keys.has('company') || keys.has('user')) {
    return false;
  }

  const contact = categories.find((c) => c.key === 'contact');
  if (!contact || (contact.fields || []).length < MIN_CONTACT_FIELDS) {
    return false;
  }

  const agency = categories.find((c) => c.key === 'agency');
  if (!agency || !(agency.fields || []).some((f) => f.value === '{{agency.name}}')) {
    return false;
  }

  const staff = categories.find((c) => c.key === 'staff');
  if (!staff || !(staff.fields || []).some((f) => f.value === '{{staff.email}}')) {
    return false;
  }

  const customValues = categories.find((c) => c.key === 'custom_values');
  if (!customValues || !(customValues.fields || []).length) {
    return false;
  }

  return true;
}

export async function fetchMergeFieldCategories(token) {
  const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  const backendUrl = rawBackendUrl.replace(/\/api$/, '');
  const api = `${backendUrl}/api`;

  if (token) {
    try {
      const axios = (await import('axios')).default;
      const response = await axios.get(`${api}/automations/merge-fields`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (isCompleteMergeFieldCatalog(response.data?.categories)) {
        return response.data.categories;
      }
    } catch {
      // Fall back to static list when API is unavailable.
    }
  }

  return STATIC_MERGE_FIELD_CATEGORIES;
}

export function collectAllMergeTokens(categories = STATIC_MERGE_FIELD_CATEGORIES) {
  return getAllMergeFields(categories).map((f) => f.value);
}
